<div class="seletor-multiplo" [class.seletor-multiplo-aberta]="aberta">
  <button
    type="button"
    class="form-select seletor-multiplo-botao"
    [disabled]="desabilitado"
    [attr.aria-expanded]="aberta"
    aria-haspopup="listbox"
    (click)="alternar()">
    {{ rotuloSelecao }}
  </button>

  <div class="seletor-multiplo-lista" *ngIf="aberta" role="listbox" (click)="$event.stopPropagation()">
    <label class="seletor-multiplo-item seletor-multiplo-todos">
      <input
        #caixaTodos
        type="checkbox"
        class="form-check-input"
        [checked]="todosSelecionados"
        (change)="alternarTodos()">
      <span>Selecionar todos</span>
    </label>

    <label class="seletor-multiplo-item" *ngFor="let departamento of departamentos">
      <input
        type="checkbox"
        class="form-check-input"
        [checked]="marcado(departamento.id)"
        (change)="alternarItem(departamento.id, $any($event.target).checked)">
      <span>{{ departamento.nome }}</span>
    </label>
  </div>
</div>
